import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const VEHICLE_DELETE_RESOURCE = "vehicle" as const;
export const VEHICLE_DELETE_API_PATH = `/v1/${VEHICLE_DELETE_RESOURCE}/{uuid}` as const;

export type VehicleDeleteResponse =
  paths[typeof VEHICLE_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useVehicleDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleDeleteResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.delete<VehicleDeleteResponse>(`/v1/${VEHICLE_DELETE_RESOURCE}/${uuid}`);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_DELETE_RESOURCE],
      });
    },
  });
};
